import React, { useState, useEffect } from "react";
import logomp from "../assets/mercadopago.png";
import logohotmart from "../assets/hotmart.png";
import qrbinance from "../assets/qrbinance.jpg";
import binance from "../assets/binance.png";

const Modal = ({ isOpen, toggleModal, link, children }) => {
  const [platform, setPlatform] = useState("default");

  useEffect(() => {
    if (link) {
      setPlatform(getPlatformFromLink(link));
    }
  }, [link]);

  function getPlatformFromLink(link) {
    // Si el link es una cadena de texto específica
    if (link === "Transferencia") {
      return "transferencia";
    }

    // Si el link es una URL
    try {
      const url = new URL(link);
      const hostname = url.hostname;

      if (hostname.includes("binance")) {
        return "binance";
      } else if (hostname.includes("mercadopago")) {
        return "mercadopago";
      } else if (hostname.includes("hotmart")) {
        return "hotmart";
      } else {
        return "default";
      }
    } catch (error) {
      console.error("URL inválida:", link);
      return "default";
    }
  }

  let logo;
  switch (platform) {
    case "binance":
      logo = qrbinance;
      break;
    case "mercadopago":
      logo = logomp;
      break;
    case "hotmart":
      logo = logohotmart;
      break;
    default:
      logo = binance;
  }

  return (
    <div
      className={`fixed z-10 inset-0 overflow-y-auto ${isOpen ? "" : "hidden"}`}
      onClick={toggleModal}
    >
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-primary opacity-75"></div>
        </div>

        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>

        <div
          className={`inline-block align-bottom bg-primary rounded-xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle ${
            platform === "binance" ? "sm:max-w-4xl" : "sm:max-w-2xl"
          } ${
            isOpen
              ? "translate-y-0 ease-out duration-300"
              : "-translate-y-full ease-in duration-200"
          }`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="bg-primary sm:px-6 sm:pb-4 sm:pt-10">
            <div className="sm:flex sm:items-start">
              <div class="flex flex-col justify-center mt-3">
                <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left mb-8">
                  <h3
                    className="text-lg leading-6 font-bold text-white sm:text-3xl tracking-tight"
                    id="modal-title"
                  >
                    Elegí el metodo de pago que más te guste.
                  </h3>
                </div>
                <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left mb-4">
                  <h3
                    className="text-lg leading-6 font-[700] text-red-600 sm:text-xl tracking-tight"
                    id="modal-title"
                  >
                    IMPORTANTE
                  </h3>
                </div>
                <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                  <h3
                    className="text-lg leading-6 font-normal text-white sm:text-[16px] mb-4"
                    id="modal-title"
                  >
                    {platform === "transferencia"
                      ? "Para realizar la compra mediante transferencia bancaria por favor comunicarse por whatsapp"
                      : "Al realizar el pago, enviar una captura de pantalla con el recibo de pago al whatsapp oficial de Rentable Inversor"}
                    <br />
                    👇
                  </h3>
                  <a
                    href="https://wa.me/5492236879502"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <button class="bg-btngreen text-white font-bold py-2 px-4 rounded flex justify-between hover:bg-green-600 transition-colors duration-200">
                      <svg
                        width="22px"
                        height="22px"
                        class="text-white mr-2"
                        viewBox="0 0 24 24"
                        version="1.1"
                        id="svg8"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          id="path4"
                          fill="white"
                          d="M16.6,14c-0.2-0.1-1.5-0.7-1.7-0.8c-0.2-0.1-0.4-0.1-0.6,0.1c-0.2,0.2-0.6,0.8-0.8,1c-0.1,0.2-0.3,0.2-0.5,0.1c-0.7-0.3-1.4-0.7-2-1.2c-0.5-0.5-1-1.1-1.4-1.7c-0.1-0.2,0-0.4,0.1-0.5c0.1-0.1,0.2-0.3,0.4-0.4c0.1-0.1,0.2-0.3,0.2-0.4c0.1-0.1,0.1-0.3,0-0.4c-0.1-0.1-0.6-1.3-0.8-1.8C9.4,7.3,9.2,7.3,9,7.3c-0.1,0-0.3,0-0.5,0C8.3,7.3,8,7.5,7.9,7.6C7.3,8.2,7,8.9,7,9.7c0.1,0.9,0.4,1.8,1,2.6c1.1,1.6,2.5,2.9,4.2,3.7c0.5,0.2,0.9,0.4,1.4,0.5c0.5,0.2,1,0.2,1.6,0.1c0.7-0.1,1.3-0.6,1.7-1.2c0.2-0.4,0.2-0.8,0.1-1.2C17,14.2,16.8,14.1,16.6,14 M19.1,4.9C15.2,1,8.9,1,5,4.9c-3.2,3.2-3.8,8.1-1.6,12L2,22l5.3-1.4c1.5,0.8,3.1,1.2,4.7,1.2h0c5.5,0,9.9-4.4,9.9-9.9C22,9.3,20.9,6.8,19.1,4.9 M16.4,18.9c-1.3,0.8-2.8,1.3-4.4,1.3h0c-1.5,0-2.9-0.4-4.2-1.1l-0.3-0.2l-3.1,0.8l0.8-3l-0.2-0.3C2.6,12.4,3.8,7.4,7.7,4.9S16.6,3.7,19,7.5C21.4,11.4,20.3,16.5,16.4,18.9"
                        />
                      </svg>
                      Whatsapp Rentable Inversor
                    </button>
                  </a>
                </div>
              </div>
              <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                <div className="mt-2 relative">
                  <a href={link} target="_blank" rel="noreferrer">
                    <img
                      src={logo}
                      alt={platform}
                      class={`w-[${
                        platform === "binance" ? "600px" : "400px"
                      }]`}
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-btngray px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <a href={link} target="_blank" rel="noreferrer">
              <button
                type="button"
                className="mt-3 w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-btngreen text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 hover:shadow hover:shadow-green-700/50 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm tracking-tight transition ease-in-out duration-300"
                onClick={toggleModal}
              >
                Proceder al pago
              </button>
            </a>
          </div>
        </div>
      </div>
      {children}
    </div>
  );
};

export default Modal;
